<div class="mobile-visible client-header">
  <div class="header-container">
    <ul>
      <div class="d-flex align-items-center">
        <!-- -------------------------------- Logo --------------------------------- -->
        <div class="logo">
          <li>
            <div class="logo-img">
              <img
                src="https://growth99.com/storage/2024/09/logo-icon.svg"
                alt=""
              />
            </div>
          </li>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <li>
          <g99-lib-notification-button
            [hasUnread]="hasUnread"
            (pressed)="onNotificationsClick()"
          />
        </li>
        <!-- -------------------- profile section ----------------------- -->

        <g99-lib-profile-popover-container
          [usersData]="usersData"
          [businessData]="businessData"
          [profileMenus]="profileMenus"
        />

        <li>
          <div class="hamburger-icon mobile-visible" (click)="toggleDock()">
            <i class="pi pi-align-justify"></i>
          </div>
        </li>
      </div>
    </ul>
  </div>
</div>

<div class="mobile-dock" [ngClass]="{ open: isDockVisible }">
  <div class="dock-content">
    <li>
      <div class="logo-img">
        <img alt="" [src]="mobileLogo" />
      </div>
    </li>

    <div class="close-button" (click)="toggleDock()">
      <i class="pi pi-times"></i>
      <!-- Close icon -->
    </div>

    <div class="business-info">
      <li class="position-relative w-100 mb-2 p-0">
        <div class="profile-section">
          <div class="business-img">
            <img
              alt=""
              class="profile-menu-img"
              [src]="businessData.logoUrl || 'assets/default-user-image.png'"
            />
          </div>

          <div class="">
            <p class="profile-subtext">
              Business ID : {{ usersData.businessId }}
            </p>
            <p class="profile-section-name mb-2">{{ businessData.name }}</p>
            <p class="profile-section-email mb-0">{{ usersData.username }}</p>
          </div>
        </div>
      </li>
    </div>

    <g99-lib-nav-menu [menuItems]="menuItems" />
  </div>
</div>
